exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reminder-indicators .material-icons[data-v-3a184104] {\n  vertical-align: middle;\n}\n.reminder-indicators > div > div[data-v-3a184104] {\n  margin-bottom: 8px;\n}\n.reminder-indicators > div > div[data-v-3a184104]:last-child {\n  margin-bottom: 0;\n}\n.due-remaining[data-v-3a184104] {\n  font-style: italic;\n  color: #999;\n}\n.status-overdue[data-v-3a184104] {\n  color: #f44336;\n  font-weight: 500;\n}\n.status-duesoon[data-v-3a184104] {\n  color: orange;\n  font-weight: 500;\n}\n.status-upcoming[data-v-3a184104] {\n  color: #999;\n  font-weight: 500;\n}\n", ""]);

// exports
